import { Skeleton } from '@mui/material';
import { ContentCard } from 'shared/components';

import AdditionalNavigationBanner from './AdditionalNavigationBanner';
import OpenOffersCountDense from './OpenOffersCountDense';

interface JobOffersOverviewProps {
    isLoading?: boolean;
}

export default function JobOffersOverview({ isLoading }: JobOffersOverviewProps) {
    if (isLoading) {
        return <OverviewSkeleton />;
    }

    return (
        <ContentCard>
            <OpenOffersCountDense />
            &nbsp;
            <AdditionalNavigationBanner />
        </ContentCard>
    );
}

function OverviewSkeleton() {
    return (
        <ContentCard>
            <Skeleton height={ 66 } />
        </ContentCard>
    );
}
